export const VERSION = "1.15.2";


// WEBPACK FOOTER //
// ../lib/env/data.js